import script from "./OtpVerify.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtpVerify.vue?vue&type=script&setup=true&lang=ts"

import "./OtpVerify.vue?vue&type=style&index=0&id=331cc47b&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-rododo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331cc47b"]])

export default __exports__